import { Url } from '@42.nl/react-url';

export const NODE_APP_URL = '/nodes';

export function toNodeApp(): Url {
  return NODE_APP_URL;
}
